'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleCache = /* @__PURE__ */ new WeakMap();
function getComputedStyle(el) {
  if (!styleCache.has(el)) {
    const win = el.ownerDocument.defaultView || window;
    styleCache.set(el, win.getComputedStyle(el));
  }
  return styleCache.get(el);
}

exports.getComputedStyle = getComputedStyle;
